// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2euHQ","dragIcon":"Choice_dragIcon__lCTW0","left":"Choice_left__21MUX","input":"Choice_input__2u1M7"};